import React from "react";
import Navbar from "./navbar/Navbar";
import {
  Switch,
  Route,
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";
import Home from "./home/Home";
import NotFound from "./NotFound";
import Market from "./market/Market";
import Management from "./managment/management/Management";
import Login from "./managment/profile/Login";
import Logout from "./managment/profile/Logout";
import Signup from "./managment/profile/Signup";
import Contact from "./contact/Contact";
import { Shop as Store } from "./market/shops/Shop";
import HelpDesk from "./helpdesk/HelpDesk";
import Terms from "./helpdesk/Terms";

class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div>
        <Router>
          <div>
            <Navbar />
          </div>

          <Switch>
            <Route path="/market/" component={Market} />
            <Redirect exact from="/" to="/market" />
            {/*<Route exact path="/" component={Landing} />*/}
            <Route path="/about/" component={Home} />
            <Route path="/login/" component={Login} />
            <Route path="/logout/" component={Logout} />
            <Route path="/contact/" component={Contact} />
            <Route
              path="/myshop/"
              render={(props) => <Management {...props} />}
            />
            <Route
              path="/shop-at/:shopName/:shopId/"
              render={(props) => <Store {...props} />}
            />
            <Route path="/signup/" render={(props) => <Signup {...props} />} />
            <Route
              path="/support/helpdesk/"
              render={(props) => <HelpDesk {...props} />}
            />
            <Route path="/terms/" render={(props) => <Terms {...props} />} />
            <Route path="" component={NotFound} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default Main;
